import React from "react";

import SearchOffIcon from "@mui/icons-material/SearchOff";
import { Box } from "@mui/material";

import { ButtonVariant } from "Constant/button";

import StandartButton from "components/atoms/StandartButton";

import * as Styled from "../LeadGeneralReportsPage.styled";

interface Props {
    onClear: () => void;
    noBorder?: boolean;
}

const EmptyState: React.FC<Props> = ({ noBorder = false, onClear }) => (
    <Styled.SectionCard elevation={0} noBorder={noBorder}>
        <Styled.EmptyStateWrap>
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: "#F1F5F9",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#94A3B8",
                }}
            >
                <SearchOffIcon sx={{ fontSize: 36 }} />
            </Box>
            <Box sx={{ fontSize: 18, fontWeight: 700, color: "#0F172A" }}>
                No data found
            </Box>
            <Box sx={{ fontSize: 13, color: "#64748B", maxWidth: 420 }}>
                There are no lead records for the selected filters. Try
                adjusting the date range or filters.
            </Box>
            <StandartButton
                variant={ButtonVariant.BLACK_OUTLINED}
                onClick={onClear}
            >
                Clear Filters
            </StandartButton>
        </Styled.EmptyStateWrap>
    </Styled.SectionCard>
);

export default EmptyState;
